<template>
  <div>
    <v-server-table
      :columns="columns"
      :options="tableOptions"
      id="kioskSessionsTable"
      ref="kioskSessionsTable"
      name="kioskSessionsTable"
      @filter="filterListener"
      @loaded="onLoaded"
    >
      <span slot="afterFilter" v-if="showResetIcon">
        <i class="fa fa-times reset-filter" @click="resetFilter"></i>
      </span>
      <span slot="facility" slot-scope="props">
        <span v-if="props.row.facility">
          <span>{{ nameWithCity(props.row.facility)}}</span>
        </span>
      </span>
      <span slot="start" slot-scope="props">
        <span v-if="props.row.start">
          <span>{{props.row.start | localTime('YYYY-MM-DD HH:mm')}}</span>
        </span>
      </span>
      <span slot="end" slot-scope="props">
        <span v-if="props.row.end">
          <span>{{props.row.end | localTime('YYYY-MM-DD HH:mm')}}</span>
        </span>
      </span>
      <span slot="promoter" slot-scope="props">
        <span v-if="props.row.user">
          <span>{{props.row.user.name}}</span>
        </span>
      </span>

    </v-server-table>
  </div>
</template>

<script>
import TableQueryMixin from '@/mixins/TableQueryMixin'
const screeningsRoute = '/screenings'
export default {
  props: {
    kiosk: {
      type: Object,
      required: false
    },
  },
  mixins: [
    TableQueryMixin
  ],
  data () {
    return {
      showResetIcon: false,
      columns: [
        'facility',
        'start',
        'end',
        'promoter'
      ],
      queryUrl: `${this.$store.state.ebooking_server}${screeningsRoute}`,
      tableOptions: {
        filterable: ['start', 'end', 'facility', 'promoter'],
        sortable: ['start', 'end'],
        headings: {
          facility: this.$t('kiosks.sessions.headers.facility'),
          start: this.$t('kiosks.sessions.headers.start'),
          end: this.$t('kiosks.sessions.headers.end'),
          promoter: this.$t('kiosks.sessions.headers.promoter')
        },
        initFilters: {
          assignedToMe: false,
          with: 'promoter.entity'
        },
        customFilters: ['promoter', 'facility', 'sessions', 'with', 'assignedToMe']
      },
    }
  },
  mounted: function () {
    let sessionIds = Array.isArray(this.kiosk.sessions) && this.kiosk.sessions.length > 0 ? this.kiosk.sessions.join(',') : '0'
    this.emitTableFilter('vue-tables.kioskSessionsTable.filter::sessions', sessionIds)
  },
  methods: {
    nameWithCity ({ name, address }) {
      if (!address) return name
      return name + ' (' + address.city + ')'
    },
    filterListener (query) {
      this.showResetIcon = query.length > 0
      this.$nextTick(() => this.$emit('kiosk-sessions-filtered', this.$refs.kioskSessionsTable.allFilteredData))
    },
    resetFilter () {
      this.showResetIcon = false
      this.$refs.kioskSessionsTable.setFilter('')
    },
    onLoaded: function (event) {
      this.$emit('loaded', event)
    }
  }
}
</script>

